// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3liVD","log":"ModalInventoryLogs_log__2BmeQ","date":"ModalInventoryLogs_date__35F4R","userName":"ModalInventoryLogs_userName__3ORNE"};